import { createApp } from 'vue'
import { install } from 'vue3-recaptcha-v2'
import App from './App.vue'
import router from './router'
import ElementPlus from './plugins/element'
import i18n from './plugins/i18n'
import store from './store/store'
import VueFeatherPlugin from './plugins/vueFeather'
import ElementIconsPlugin from './plugins/elementIcons'
import VueVirtualScroller from 'vue3-virtual-scroller'
import '@hotelkeyrepo/hk-ui-toolkit-vue-3/dist/style.css';
import '@hotelkeyrepo/hk-ui-toolkit-vue-3/src/assets/global.css'
import 'normalize.css/normalize.css'
import '@/assets/style/main.scss'
import '@/common/polyfills'
import 'vue3-virtual-scroller/dist/vue3-virtual-scroller.css'
import { createPinia } from 'pinia';
import { loadAppDynamics, attachAdrumScript } from '@hotelkeyrepo/hk-ui-utilities-vue-3/src/common/services/utilities.service';
import { Buffer } from 'buffer'
import deepClone from 'clone';
import '@hotelkeyrepo/hk-trainkey-vue-3/src/trainkey/init';
import '@hotelkeyrepo/hk-trainkey-vue-3/src/trainkey/plugins/flowy-vue/dist/lib/style.css';
import vtooltip from "@hotelkeyrepo/hk-trainkey-vue-3/src/trainkey/directives/v-training/v-tooltip"
import { installA11yDirectives } from "vue-a11y-directives";
// add buffer in global window
window.Buffer = Buffer


const app = createApp(App)
const pinia = createPinia();
app.directive("hotelkey-tip", vtooltip);
installA11yDirectives(app);

// const isProduction = window.hkConfigEnvs.NODE_ENV === 'production'


app.use(pinia);
app.use(install)
app.use(router)
app.use(ElementPlus)
app.use(i18n)
app.use(VueVirtualScroller)
app.use(store)
app.use(VueFeatherPlugin)
app.use(ElementIconsPlugin)
app.config.globalProperties.$deepClone = deepClone;

app.mount('#app')

//adrum 
if(window.hkConfigEnvs.VUE_APP_DYNAMICS_KEY){
    loadAppDynamics({appDynamicsKey: window.hkConfigEnvs.VUE_APP_DYNAMICS_KEY})
    attachAdrumScript()
}

